import config from 'react-global-configuration';
export var LANGUAGE_SET = 'LANGUAGE_SET';
export function setLanguage(language) {
  return {
    type: LANGUAGE_SET,
    language: language
  };
}
export var ROOT_CLASSES_ADD = 'ROOT_CLASSES_ADD';
export function addRootClasses(classes) {
  return {
    type: ROOT_CLASSES_ADD,
    classes: classes
  };
}
export var ROOT_CLASSES_REMOVE = 'ROOT_CLASSES_REMOVE';
export function removeRootClasses(classes) {
  return {
    type: ROOT_CLASSES_REMOVE,
    classes: classes
  };
}
export var ENABLE_MAINTENANCE_MODE = 'ENABLE_MAINTENANCE_MODE';
export function enableMaintenanceMode() {
  return {
    type: ENABLE_MAINTENANCE_MODE
  };
}
export var DISABLE_MAINTENANCE_MODE = 'DISABLE_MAINTENANCE_MODE';
export function disableMaintenanceMode() {
  return {
    type: DISABLE_MAINTENANCE_MODE
  };
}
export var SET_CHECKBOX = 'SET_CHECKBOX';
export function setCheckbox(id, checked) {
  return {
    type: SET_CHECKBOX,
    id: id,
    checked: checked
  };
}
export var PERMISSIONS_LOADED = 'PERMISSIONS_LOADED';
export var permissionsLoaded = function permissionsLoaded(permissions) {
  return {
    type: PERMISSIONS_LOADED,
    payload: permissions
  };
};
export var getPermissions = function getPermissions() {
  return function (dispatch, getState) {
    var API_URL = config.get('API_URL');
    var language = getState().getIn(['ui', 'language']);
    var MULTILINGUAL = config.get('MULTILINGUAL', true);
    var PATH = MULTILINGUAL ? "".concat(API_URL, "/").concat(language) : API_URL;
    fetch("".concat(PATH, "/api/user/permissions"), {
      credentials: 'include'
    }).then(function (response) {
      try {
        return response.json();
      } catch (_unused) {
        throw new Error();
      }
    }).then(function (response) {
      dispatch(permissionsLoaded(response));
    }).catch(function () {});
  };
};
export var UI_OPERATION_STATUS_REQUEST = 'UI_OPERATION_STATUS_REQUEST';
export var UI_OPERATION_STATUS_SUCCESS = 'UI_OPERATION_STATUS_SUCCESS';
export var UI_OPERATION_STATUS_ERROR = 'UI_OPERATION_STATUS_ERROR';
export var UI_OPERATION_STATUS_REASON_BLOCKED = 'BLOCKED';
export var UI_OPERATION_STATUS_REASON_FLOOD = 'FLOOD';
export var UI_OPERATION_STATUS_REASON_UNRECOGNIZED = 'UNRECOGNIZED';
export var UI_OPERATION_STATUS_REASON_UNKNOWN = 'UNKNOWN';
export var UI_OPERATION_SET_STATUS = 'UI_OPERATION_SET_STATUS';
export function setOperationStatus(type, operation, status, reason) {
  return {
    type: UI_OPERATION_SET_STATUS,
    payload: {
      type: type,
      operation: operation,
      status: status,
      reason: reason
    }
  };
}